import { notify, PreviewSnippet } from '@cast/design-system';
import { KentKentrollerLastFalseCondition } from '@cast/types-kent';

type Props = {
  lastFalseCondition: KentKentrollerLastFalseCondition;
  maxHeight?: number;
};

export const KentrollerLastFalseConditionDetails = ({
  lastFalseCondition,
  maxHeight,
}: Props) => {
  return (
    <PreviewSnippet
      testId="kent-kentroller-status-last-false-condition"
      code={JSON.stringify(lastFalseCondition, null, 2)}
      language="json"
      errorHighlight
      maxHeight={maxHeight}
      onCopy={() => {
        notify.success('Copied to clipboard');
      }}
    />
  );
};
